<script>

import {axios} from '../../mixins';
import {Carousel, Icon, Navigation, Pagination, Slide} from 'vue3-carousel'
import 'vue3-carousel/dist/carousel.css';
import ValidationIcon from "../ValidationIcon.vue";
import moment from 'moment';
import OperationsModal from "./OperationsModal";
import Modal from ".././Modal";
import OperationsForm from '.././Operations/Form.vue';
import {Alerts} from "../../mixins/Alerts.js";
import FieldYearsForm from ".././FieldYears/Form";

moment().format()

export default {
  name: "OperationsCarousel",

  components: {
    Carousel,
    Slide,
    Icon, Navigation, Pagination,
    ValidationIcon,
    OperationsModal,
    OperationsForm,
    FieldYearsForm,
    Modal,
  },

  mixins: [
      axios
  ],

  props: {
    data: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
    defaultUnits: {
      type: Object,
      required: false,
    },
    operationTypes: {
      type: Object,
      required: true,
    },
    requiredOperations: {
      type: Object,
      required: true,
    },
    additionalityTypes: {
      type: Object,
      required: false,
      default: [],
    },
    mapboxToken: {
      type: String,
      required: true,
    },
    copiedFieldYear: {
      type: Object,
      required: false,
    },
    locked: {
      type: Boolean,
      required: false,
    }
  },

  created() {
    this.fieldYears = this.data.carouselData
    this.admin = this.data.admin
    this.super = this.data.super
    this.activeYear = this.yearIndex = this.data.activeYear
    this.years = this.data.years ?? []
    this.fieldID = this.data.fieldID
    this.fields = this.data.fields
    this.interventionYear = this.data.interventionYear
    this.copiedField = this.copiedFieldYear
    this.scrollCarouselToYear()
  },

  data() {
    return {
      breakpoints: {
        1: {
          itemsToShow: 1,
          snapAlign: 'start',
        },
        640: {
          itemsToShow: 2,
          snapAlign: 'start',
        },
        768: {
          itemsToShow: 3,
          snapAlign: 'start',
        },
        1024: {
          itemsToShow: 4,
          snapAlign: 'start',
        },
        1280: {
          itemsToShow: 5,
          snapAlign: 'start',
        },
        1536: {
          itemsToShow: 6,
          snapAlign: 'start',
        },
        1792: {
          itemsToShow: 7,
          snapAlign: 'start',
        },
        2048: {
          itemsToShow: 8,
          snapAlign: 'start',
        },
      },
      years: [],
      yearIndex: 0,
      interventionYear: 0,
      fieldYears: [],
      fieldID: 0,
      fieldName: '',
      fields: [],
      admin: false,
      super: false,
      activeYear: 0,
      modalData: {},
      alerts: new Alerts(),
      toolTips: {
        'operations': false,
        'copy': false,
        'edit': false,
        'intervention': false,
        'additionalities': false,
      },
      copiedField: null,
      selectedYear: null,
      // For loading indicator of copy/paste
      cloningYear: null,
      selectedCrop: -1,
      // Prevents drags from opening modal
      isDragging: false,
      startX: null,
      startY: null,
      reloadComponents: 0,
    }
  },

  methods: {
    scrollCarouselToYear() {
      this.$nextTick(function () {
        if (!this.years || this.years.length === 0) {
          return;
        }
        const target = (this.selectedYear ?? this.activeYear);
        let idx = this.years.indexOf(target);
        if (idx === -1) {
          idx = 0;
        }
        idx = Math.max(0, idx - 1);
        this.yearIndex = idx;
        if (this.$refs['carousel']) {
          this.$refs['carousel'].slideTo(this.yearIndex);
        }
      })
    },

    barStatus(currentYear, interventionYear) {
      let result = '';
      if (currentYear < interventionYear) {
        result += 'bg-yellow '
      } else {
        result += 'bg-green '
      }
      if (currentYear === interventionYear || currentYear === this.years[0]) {
        result += 'rounded-l-lg '
      }
      if (currentYear === interventionYear - 1 || currentYear === this.years[this.years.length - 1]) {
        result += 'rounded-r-lg '
      } else {
        result += '-mr-4 '
      }
      return result;
    },

    validateResource(resource) {
      let messages
      this.get('/validate/' + resource.type + '/' + resource.id).then((response) => {
        // Operations return objects
        messages = response.data.errors

        if (messages.length === 0) {
          messages = [
            ['Data is valid.']
          ]
        }

        let refResource = this.$refs[resource.reference ?? (resource.type + `-` + resource.id)]
        if (Array.isArray(refResource)) {
          refResource = refResource[0]
        }
        refResource.setMessages(messages)
      }).catch((errors) => {
        messages = [errors]

        let refResource = this.$refs[resource.reference ?? (resource.type + `-` + resource.id)]
        if (Array.isArray(refResource)) {
          refResource = refResource[0]
        }
        refResource.setMessages(messages)
      });
    },

    formatDate(date) {
      return moment(date, "YYYY-MM-DD").format('MM-DD-YYYY')
    },

    openModal(operation, year, data) {
      if (this.isDragging) {
        this.isDragging = false;
        return;
      }

      this.modalData = {
        'year' : year,
        'crops' : data ? data.crops : {},
        'is_valid' : data ? data.is_valid : null,
        'intervention_year' : data ? data.intervention_year : null,
      }

      this.$refs.operationsModal.open()
      if (operation) {
        this.showOperation(operation)
      } else if (this.modalData.crops) {
        // Show first crop if one exists, or open crop adding
        this.showCrop(Object.keys(this.modalData.crops)[0], 0);
      } else {
        this.showCrop(0, 0);
      }
    },

    setModalView(view) {
      this.modalData.view = view;
    },

    emptyFieldYear(year) {
      return {
        year: year,
        field_id: this.fieldID,
        field_name: this.fieldName,
      }
    },

    showCrop(cropId, cropIndex) {
      this.modalData.selectedCropIndex = moment.localeData().ordinal(cropIndex + 1);
      this.modalData.selectedOperationId = this.modalData.selectedOperationType = 0;
      this.modalData.selectedCrop = this.modalData.previousCrop = cropId;

      this.$nextTick(function () {
        this.setModalView('crops')
      })
    },

    setCrop() {
      if (!this.modalData.selectedCrop) {
        return;
      }

      // Only push if a field year exists AND the previous crop is valid
      if (this.fieldYears[this.modalData.year] && this.modalData.previousCrop) {
        let data = {
          crop_id: this.modalData.selectedCrop,
          previous_crop_id: this.modalData.previousCrop,
          field_year_id: this.fieldYears[this.modalData.year].id,
          delete: false,
        }

        // Sets all existing crops under the current crop to the new crop
        this.post('field_years/manage-crop', data).then((response) => {
          this.modalData.status = true;
          this.modalData.message = response.data.message;
          this.loadFieldYears()
        }).catch((errors) => {
          console.log(errors)
        })
      } else {
        // Set local "crops" data on the field year.
        // Adding an operation will use the newly set crop
        let operations = []
        console.log(this.requiredOperations)
        this.requiredOperations.forEach((op) => {
          console.log(op)
          operations.push(this.emptyOperation(this.modalData.year, this.modalData.selectedCrop, op));
        })

        this.modalData.crops
            ? this.modalData.crops[this.modalData.selectedCrop] = operations
            : this.modalData.crops = {
              [this.modalData.selectedCrop]: operations
            }
      }
    },

    removeCrop() {
      // If no operations have IDs, this crop is only local (and possibly added accidentally)
      let hasOperations = false;
      for (let [index, operation] of Object.entries(this.modalData.crops[this.modalData.selectedCrop])) {
        if (operation.id !== null) {
          hasOperations = true;
          break;
        }
      } if (!hasOperations) {
        delete this.modalData.crops[this.modalData.selectedCrop];
        this.showCrop(0, 0);
      }

      // Make delete request if there is a valid field year, and operations have IDs
      else if (this.fieldYears[this.modalData.year]) {
        let data = {
          field_year_id: this.fieldYears[this.modalData.year].id,
          crop_id: this.modalData.selectedCrop,
          delete: true
        }

        this.post('field_years/manage-crop', data).then((response) => {
          this.modalData.status = true;
          this.modalData.message = response.data.message;
          this.showCrop(0, 0)
          this.loadFieldYears()
        }).catch((errors) => {
          console.log(errors)
        })
      }

      this.$refs.deleteCropModal.close()
    },

    showOperation(operation, year, crop) {
      this.$nextTick(function () {
        // Clear modal view to reset form
        this.setModalView('');
      });

      // Set crop to automatically fill hidden crop_id on operation
      this.modalData.selectedCrop = this.modalData.previousCrop = crop

      if (!operation) {
        operation = this.emptyOperation(year, crop)
      }

      this.modalData.operation = {
        'id': operation.id,
        'table': this.operationTypes[operation.operation_type_id],
        'data' : operation,
      }

      // For "active" display changes
      this.modalData.selectedOperationId = operation.id
      this.modalData.selectedOperationType = operation.operation_type_id

      this.$nextTick(function () {
        this.setModalView('operations')
      });
    },

    emptyOperation(year, crop, type) {
      return {
        'field_year_id': this.fieldYears[year] ? this.fieldYears[year].id : null,
        'field_id': this.fieldID,
        'year': Number(year),
        'id': null,
        'type': Number(type) ?? 0,
        'operation_type_id': Number(type) ?? 0,
        'crop_id' : Number(crop) ?? 0,
      };
    },

    isActiveCrop(crop) {
      return (crop === this.modalData.selectedCrop)
    },

    isActiveOperation(operation) {
      return (operation.id === this.modalData.selectedOperationId
          && this.modalData.selectedOperationType === operation.operation_type_id)
    },

    loadFieldYears() {
      this.get('/carousel/' + this.fieldID).then((response) => {
        this.fieldYears = response.data.carouselData
        this.interventionYear = response.data.interventionYear
        this.years = response.data.years ?? []
        if (this.modalData.year) {
          this.modalData.crops = null
          this.$nextTick(function () {
            if (this.fieldYears[this.modalData.year]) {
              this.modalData.crops = this.fieldYears[this.modalData.year].crops

              for (let [crop, operations] of Object.entries(this.modalData.crops)) {
                // Set empty data for any necessary operations that are missing
                let neededOperations = [1, 4, 7];
                for (let operation in operations) {
                  if (neededOperations.includes(operations[operation].operation_type_id)) {
                    neededOperations.splice(neededOperations.indexOf(operations[operation].operation_type_id), 1)
                  }
                }

                for (let operation of neededOperations) {
                  this.modalData.crops[crop].push(this.emptyOperation(this.modalData.year, crop, operation))
                }
              }
            }
          })
        }
        this.reloadComponents += 1;
        this.scrollCarouselToYear()
      })
    },

    updateResource(resource, table) {
      this.setModalMessage(null, null)
      this.alerts.initialize()
      if (table) {
        resource.table = table
      }
      this.patch(resource.table + '/' + resource.id, resource.data).then((response) => {
        if (resource.table !== 'field_years') {
          this.$refs.operationsForm.submitting = false;
          this.showOperation(response.data.resource)
        }

        this.setModalMessage('Success', true)
        this.loadFieldYears()
        this.$emit('validateResource', {id: this.fieldID, type: 'fields'})
      }).catch((errors) => {
        if (resource.table !== 'field_years') {
          this.$refs.operationsForm.submitting = false;
        }
        if (errors.response.data.errors) {
          this.alerts.recordErrors(errors.response.data.errors)
        }
        if (errors.response.statusText) {
          this.setModalMessage(errors.response.statusText, false)
        }
      });
    },

    storeResource(resource, table) {
      this.setModalMessage(null, null)
      if (table) {
        resource.table = table
      }
      this.alerts.initialize()
      this.post(resource.table, resource.data).then((response) => {
        if (resource.table !== 'field_years') {
          this.$refs.operationsForm.submitting = false;
          this.showOperation(response.data.resource)
          this.modalData.selectedCrop = null;
        }

        this.setModalMessage('Success', true)
        this.loadFieldYears()
        this.$emit('validateResource', {id: this.fieldID, type: 'fields'})
      }).catch((errors) => {
        if (resource.table !== 'field_years') {
          this.$refs.operationsForm.submitting = false;
        }
        if (errors.response.data.errors) {
          this.alerts.recordErrors(errors.response.data.errors)
        }
        if (errors.response.statusText) {
          this.setModalMessage(errors.response.statusText, false)
        }
        if (resource.type === 'fields' && this.alerts.getError('boundary')) {
          this.boundaryError = true;
        }
      });
    },

    deleteResource(resource, table) {
      this.alerts.initialize()
      resource.table = table ?? resource.table
      this.delete(resource.table + '/' + resource.id).then(() => {
        if (resource.table === 'field_years') {
          this.modalData.year = null;
          this.$refs.operationsModal.close()
          this.loadFieldYears()
        } else {
          let index = (this.modalData.crops[resource.data.crop_id]).findIndex((item) => (item.id === resource.data.id && this.operationTypes[item.operation_type_id] === this.operationTypes[resource.data.operation_type_id]))
          let cropIndex = (Object.keys(this.modalData.crops).indexOf(resource.data.id)) + 1
          this.modalData.crops[resource.data.crop_id].splice(index, 1);
          this.modalData.edit = false;
          this.setModalMessage('Success! Operation has been deleted.', true)
          this.showCrop(resource.data.crop_id, cropIndex)
        }

        this.$emit('validateResource', {id: this.fieldID, type: 'fields'})
      })
    },

    setModalMessage(message, status) {
      this.modalData.message = message
      this.modalData.status = status ?? false
    },

    cloneOperations(fieldId, year, fieldYearToClone) {
      this.modalData.cloning = true
      this.selectedYear = year
      this.alerts.initialize()

      let data = {
        field_id: fieldId,
        year: year,
        field_year_to_clone_id: fieldYearToClone,
      }

      this.post('/field_years/clone', data).then((response) => {
        if (response.data.status === 'failed') {
          this.alerts.recordErrors([response.data.message])
        } else {
          this.loadFieldYears()
        }

        this.setModalMessage('Success! Field year data has been cloned.', true)

        this.$emit('validateResource', {id: this.fieldID, type: 'fields'})
        this.scrollCarouselToYear()
        this.modalData.cloning = false
        this.cloningYear = null;
      }).catch(() => {
        this.modalData.cloning = false
      });
    },

    setInterventionYear() {
      let data = {field_year_id : this.fieldYears[this.modalData.year].id}
      this.post('field_years/set-intervention-year', data).then((response) => {
        if (response.data.status === 'error') {
          this.alerts.recordErrors([response.data.message])
        } else {
          this.modalData.status = true;
          this.modalData.message = 'Success! Intervention year set.'
          this.loadFieldYears()
        }
      })
    },

    additionalityTextInput(additionality) {
      additionality.text_box = (event.target.value === 7 || event.target.value === '7');
    },

    addAdditionality(fieldYear) {
      let additionality = {};
      additionality.type = null;
      additionality.text_box = false;
      additionality.new = true;
      fieldYear.additionalities.push(additionality)
    },

    setAdditionalities(fieldYear) {
      this.post('additionalities/set-additionalities', fieldYear).then((response) => {
        if (response.data.errors) {
          this.alerts.recordErrors([response.data.message])
        } else {
          this.setModalMessage('Success! Additionalities saved.', true)
          this.loadFieldYears()
        }
      })
    },

    copyFieldYear(fieldYear) {
      this.clearCopiedData(true)
      this.copiedField = fieldYear
      this.$emit('copyFieldYear', this.copiedField)
    },

    clearCopiedData(emit) {
      this.copiedField = null
      if (emit) {
        this.$emit('clearCopiedData')
      }
    },

    pasteFieldYear(year) {
      this.cloningYear = year;
      this.cloneOperations(this.fieldID, year, this.copiedField.id)
    },

    handleMouseDown(event) {
      this.isDragging = false;
      this.startX = event.clientX;
      this.startY = event.clientY;
    },

    handleMouseMove(event) {
      const deltaX = Math.abs(event.clientX - this.startX);
      const deltaY = Math.abs(event.clientY - this.startY);
      if (deltaX > 5 || deltaY > 5) {
        this.isDragging = true;
      }
    },

    getOperationName(operation) {
      switch (operation.operation_type_id) {
        // Show tillage implement, if possible
        case 1:
          return operation.implement ? this.options.implement[operation.implement].label : 'Tillage'
        // Add cover crop species (or crop_id if none found)
        case 8:
          return this.options.operation_type_id[operation.operation_type_id].label
              + ' (' + this.options.crop_id[operation.cover_crop_species ?? operation.crop_id].label + ')'
        default:
          return this.options.operation_type_id[operation.operation_type_id].label
      }
    },

    handleErrors(errors) {
      if (errors.response.data.errors) {
        this.alerts.recordErrors(errors.response.data.errors)
      }
      if (errors.response.statusText) {
        this.setModalMessage(errors.response.statusText, false)
      }
    }
  }
}
</script>

<template>
  <div v-if="years.length === 0" class="p-4 text-center italic text-grey">
    No crop years are required.
  </div>
  <carousel v-else :ref="`carousel`" v-model="yearIndex" :breakpoints="breakpoints">
    <slide v-for="(year, index) in this.years" :key="index">
      <div class="h-full mx-2 my-1 w-full overflow-visible"
           @mousedown="handleMouseDown"
           @mousemove="handleMouseMove">
        <div v-if="this.interventionYear"
             class="min-w-full p-2 mb-2 overflow-visible"
             :class="this.barStatus(year, this.interventionYear, this.years)">
        </div>

        <div class="flex">
          <div class="rounded-t bg-secondary tab-shadow px-4 py-2">
            <div class="text-xl font-semibold">
              <div class="hover:text-blue flex flex-row"
                   @click="openModal(null, year, this.fieldYears[year] ? this.fieldYears[year] : this.emptyFieldYear(year))">
                <div v-if="this.fieldYears[year]" :id="`field_years-` + year">
                  <ValidationIcon resourceType="field_years" placement="bottom"
                                  :key="this.reloadComponents"
                                  :resourceId="this.fieldYears[year].id"
                                  :isValid="this.fieldYears[year].is_valid"
                                  :hasWarning="this.fieldYears[year].has_warning"
                                  :ref="`field_years-` + this.fieldYears[year].id"
                                  @validate="validateResource"
                                  @loadFieldYears="loadFieldYears"
                  >
                    <template #is-valid="valid">
                      <span v-show="this.fieldYears[year].is_valid && !this.fieldYears[year].has_warning" class="text-green">
                        <i class="fas fa-check-circle"></i>
                      </span>
                      <span v-show="this.fieldYears[year].is_valid && this.fieldYears[year].has_warning" class="text-yellow-dark">
                        <i class="fas fa-warning"></i>
                      </span>
                      <span v-show="!this.fieldYears[year].is_valid" class="text-red">
                        <i class="fas fa-circle-exclamation"></i>
                      </span>
                    </template>
                  </ValidationIcon>
                </div>
                <span class="pl-2">{{ year }}</span>
                <div v-if="this.interventionYear === year">
                  <i class="fas fa-flag-pennant pl-2"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="rounded-b rounded-tr tile-shadow bg-secondary pl-2">
          <div v-if="this.cloningYear === year" class="p-4 text-xl text-grey italic flex">
            <div class="m-auto">
              Cloning...
            </div>
          </div>

          <div class="text-lg text-left leading-tight" v-else-if="this.fieldYears[year] && Object.keys(this.fieldYears[year].crops).length > 0">
            <!-- CROPS -->
            <div class="overflow-y-auto pr-4 h-64">
              <template v-for="(operations, crop, index) in this.fieldYears[year].crops">
                <div class="text-lg font-semibold pb-1">
                  {{ crop ? this.options.crop_id[crop].label : 'Crop' }}
                </div>

                <!-- OPERATIONS -->
                <template v-for="(operation, operationIndex) in operations">
                  <div @click="openModal(operation, year, fieldYears[year], operationIndex)"
                       class="flex cursor-pointer border-t border-grey-lighter">
                    <div class="w-[15%] flex">
                      <ValidationIcon :resourceType="operation.table" :resourceId="operation.id"
                                      :key="this.reloadComponents"
                                      placement="bottom"
                                      classes="my-auto"
                                      :isValid="operation.is_valid"
                                      :hasWarning="operation.has_warning"
                                      :ref="operation.table + `-` + operation.id"
                                      @validate="validateResource"
                                      @loadFieldYears="loadFieldYears"
                      >
                        <template #is-valid="valid">
                          <span v-show="operation.is_valid && !operation.has_warning" class="text-green">
                            <i class="fas fa-check"></i>
                          </span>
                          <span v-show="operation.is_valid && operation.has_warning" class="text-yellow-dark">
                            <i class="fas fa-warning"></i>
                          </span>
                          <span v-show="!operation.is_valid" class="text-red">
                            <i class="fas fa-exclamation"></i>
                          </span>
                        </template>
                      </ValidationIcon>
                    </div>

                    <div class="w-[85%]">
                      <h3 class="text-md">
                        {{ this.getOperationName(operation) }}
                      </h3>
                      <p class="text-sm">
                        {{ formatDate(operation.date) }}
                      </p>
                    </div>
                  </div>
                </template>
              </template>
            </div>

            <!-- BUTTONS -->
            <div v-if="Object.keys(this.fieldYears[year].crops).length > 0 && !this.locked" class="py-2 pr-2 flex justify-between text-sm text-blue">
              <div v-if="!this.copiedField"
                   class="button bg-primary border-blue hover:bg-grey-lightest focus:bg-grey-lighter"
                   @click="copyFieldYear(this.fieldYears[year])">
                <span><i class="fas fa-copy"></i></span>
                <span class="pl-1">Copy</span>
              </div>

              <div v-if="this.copiedField ? this.fieldYears[year].id === this.copiedField.id : false"
                   class="button bg-primary border-blue hover:bg-grey-lightest focus:bg-grey-lighter"
                   @click="clearCopiedData(true)">
                <span><i class="fas fa-eraser"></i></span>
                <span class="pl-1">Cancel Copy</span>
              </div>

              <div v-if="(this.copiedField && this.copiedField.id !== this.fieldYears[year].id)"
                   class="button bg-primary border-blue hover:bg-grey-lightest focus:bg-grey-lighter"
                   @click="pasteFieldYear(year)">
                <span><i class="fas fa-paste"></i></span>
                <span class="pl-1">Paste</span>
              </div>

              <div class="button bg-primary border-blue hover:bg-grey-lightest focus:bg-grey-lighter"
                   @click="openModal(null, year, this.fieldYears[year])">
                <span><i class="fas fa-pen-to-square"></i></span>
                <span class="pl-1">Edit</span>
              </div>
            </div>
          </div>

          <div v-else class="leading-tight">
            <div class="p-4 text-xl text-grey italic h-64 flex">
              <div class="m-auto">
                {{ !this.locked ? 'Select a Crop' : 'No Crop Selected' }}
              </div>
            </div>
            <div class="py-2 flex justify-between text-sm text-blue w-full">
              <div v-if="this.copiedField"
                   class="bg-primary px-2 py-1 rounded tile-shadow border border-blue flex justify-center cursor-pointer"
                   @click="pasteFieldYear(year)">
                <span><i class="fas fa-paste"></i></span>
                <span class="pl-1">Paste</span>
              </div>

              <div class="bg-primary px-2 py-1 rounded tile-shadow border border-blue flex justify-center cursor-pointer"
                   :class="!this.copiedField ? 'grow' : ''"
                   @click="openModal(null, year, this.emptyFieldYear(year))"
                   v-if="!this.locked">
                <span>
                  <i class="fas fa-location-arrow"></i>
                </span>
                <span class="px-1">
                  Start
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </slide>
    <template #addons>
      <Navigation>
        <template #next>
          <i class="fas fa-chevron-right text-sm"/>
        </template>
        <template #prev>
          <i class="fas fa-chevron-left text-sm"/>
        </template>
      </Navigation>
      <Pagination />
    </template>
  </carousel>

  <!-- OPERATIONS MODAL -->
  <OperationsModal ref="operationsModal" :small="true">
    <div class="flex justify-between w-full">
      <!-- YEAR DISPLAY -->
      <div class="rounded-t bg-secondary tab-shadow px-4 py-2 text-lg font-semibold block z-20">
        {{ this.modalData.year }}
      </div>

      <!-- MESSAGE BOX -->
      <div v-if="this.modalData.message"
           class="ml-2 px-4 py-2 rounded-t tab-shadow bg-secondary float-right">
        <i v-if="this.modalData.status" class="far fa-check-circle text-green"></i>
        <i v-else class="far fa-xmark-circle text-red"></i>
        {{ this.modalData.message }}
      </div>
    </div>

    <!-- CONTENT -->
    <div class="bg-secondary p-2 h-128 lg:h-192 w-full flex flex-col lg:flex-row justify-between tab-shadow" :class="modalData.message ? '' : 'rounded-tr'">
      <!-- OPERATIONS LIST -->
      <div class="lg:w-1/3 h-48 lg:h-auto shrink-0 rounded-l bg-tertiary overflow-auto">
        <template v-if="!this.modalData.crops">
          <div class="pl-1 py-1 text-left text-xl font-semibold bg-primary" @click="showCrop(0, 0)">
            Select a crop
            <i class="float-right fas fa-chevron-left p-2 text-sm my-auto"></i>
          </div>
        </template>
        <div v-else>
          <template v-for="(operations, crop, cropIndex) in this.modalData.crops">
            <div class="p-1 text-left text-xl font-semibold cusor-pointer flex justify-between" :class="crop == this.modalData.selectedCrop ? 'bg-primary' : ''"
                 @click="showCrop(crop, cropIndex)">
              {{ this.options.crop_id[crop].label }}
              <span v-if="isActiveCrop(crop)" class="p-2 text-sm my-auto"><i class="fas fa-chevron-left"></i></span>
              <span v-if="!isActiveCrop(crop)" class="p-2 text-sm my-auto"><i class="fas fa-chevron-right"></i></span>
            </div>

            <template v-for="(operation, index) in operations">
              <div class="px-1 cursor-pointer border-b border-white"
                   :class="isActiveOperation(operation) ? 'bg-primary' : ''"
                   @click="showOperation(operation, index)">
                <div class="text-md flex justify-between">
                  <div class="flex">
                    <div class="m-auto w-4 text-center">
                      <ValidationIcon :resourceType="operation.table" :resourceId="operation.id"
                                      :key="this.reloadComponents"
                                      placement="bottom"
                                      :isValid="operation.is_valid"
                                      :hasWarning="operation.has_warning"
                                      :ref="`card-` + operation.table + `-` + operation.id"
                                      :reference="`card-` + operation.table + `-` + operation.id"
                                      @validate="validateResource"
                                      @loadFieldYears="loadFieldYears"
                      >
                        <template #is-valid="valid">
                          <span v-show="operation.is_valid && !operation.has_warning" class="text-green">
                            <i class="fas fa-check"></i>
                          </span>
                          <span v-show="operation.is_valid && operation.has_warning" class="text-yellow-dark pr-2">
                            <i class="fas fa-warning"></i>
                          </span>
                          <span v-show="!operation.is_valid" class="text-red">
                            <i class="fas fa-exclamation"></i>
                          </span>
                        </template>
                      </ValidationIcon>
                    </div>
                    <div class="mx-1">
                      {{ (operation.operation_type_id !== 1)
                        ? this.options.operation_type_id[operation.operation_type_id].label
                        : operation.implement ? this.options.implement[operation.implement].label : 'Tillage' }}
                      <p class="text-sm text-left">
                        {{ formatDate(operation.date) }}
                      </p>
                    </div>
                  </div>
                  <span v-if="isActiveOperation(operation)" class="p-2 text-sm my-auto">
                    <i class="fas fa-chevron-left"></i>
                  </span>
                  <span v-if="!isActiveOperation(operation)" class="p-2 text-sm my-auto">
                    <i class="fas fa-chevron-right"></i>
                  </span>
                </div>
              </div>
            </template>
            <div class="pl-3 cursor-pointer"
                 :class="(isActiveOperation(emptyOperation(this.modalData.year, crop)) && isActiveCrop(crop)) ? 'bg-primary' : ''"
                 @click="showOperation(null, this.modalData.year, crop)">
              <div class="text-md py-1"><i class="far fa-gear"></i> Add Operation</div>
            </div>
          </template>
          <div class="pl-3 cursor-pointer"
               :class="isActiveCrop(0) ? 'bg-primary' : ''"
               @click="showCrop(0, Object.keys(this.modalData.crops).length)">
            <div class="text-md py-2"><i class="far fa-corn"></i> Add Crop</div>
          </div>
        </div>
      </div>

      <!-- EDITOR -->
      <div class="bg-primary rounded-r overflow-auto w-full px-2">
        <!-- CROP VIEW -->
        <div v-if="modalData.view === 'crops'" class="flex flex-col justify-between h-full py-2">
          <div class="flex flex-col">
            <div class="text-lg font-semibold border-b border-grey-lighter">{{ this.modalData.selectedCropIndex }} Crop</div>
            <div class="mt-2">Select Crop</div>
            <select v-model="modalData.selectedCrop"
                    :disabled="this.locked"
                    class="bg-tertiary italic border-b border-grey-light w-full py-2 px-3 leading-tight focus:outline-none focus:ring">
              <template v-for="crop in this.options.crop_id">
                <option v-show="crop.local_active === true || crop.value === modalData.selectedCrop" :value="crop.value">
                  {{ crop.label }}
                </option>
              </template>
            </select>
          </div>

          <div class="w-full flex justify-between">
            <button class="button text-white font-bold bg-red hover:bg-red-dark focus:bg-red-darker disabled:cursor-not-allowed"
                    @click="this.$refs.deleteCropModal.open()"
                    :disabled="this.locked">
              <span class="mr-1"><i class="fas fa-trash"/></span>
              <span>Remove</span>
            </button>

            <button class="button text-white font-bold bg-green hover:bg-green-dark focus:bg-green-darker"
                    @click="setCrop()"
                    :disabled="this.locked">
              <span class="mr-1"><i class="far fa-wheat"/></span>
              <span>Set Crop</span>
            </button>
          </div>
        </div>

        <Modal :small="true" ref="deleteCropModal">
          <div class="flex flex-row p-6 text-black">
            <i class="fad fa-3x fa-exclamation-triangle"></i>
            <div class="flex flex-col pl-4">
              <p>
                Are you sure you want to remove this crop? All associated operations will be deleted.
              </p>
              <p>
                This process cannot be undone.
              </p>
            </div>
          </div>

          <template #footer="{close,cancel}">
            <div class="w-full flex justify-between">
              <button class="button font-bold bg-primary hover:bg-grey-lightest focus:bg-grey-lighter"
                      @click="close">
                <span>Cancel</span>
              </button>

              <button class="button text-white font-bold bg-red hover:bg-red-dark focus:bg-red-darker"
                      @click="removeCrop">
                <span class="mr-1"><i class="fas fa-trash"/></span>
                <span>Yes, Remove</span>
              </button>
            </div>
          </template>
        </Modal>


        <!-- OPERATIONS VIEW -->
        <div v-if="modalData.view === 'operations'">
          <OperationsForm
              ref="operationsForm"
              :resource="modalData.operation"
              @update="updateResource"
              @delete="deleteResource"
              @store="storeResource"
              @validate="validateResource"
              @loadFieldYears="loadFieldYears"
              :types="operationTypes"
              :options="this.options"
              :alerts="this.alerts"
              :locked="this.locked"
              :defaultUnits="this.defaultUnits">
          </OperationsForm>
        </div>

        <!-- SET INTERVENTION YEAR -->
        <div v-if="this.modalData.view === 'intervention'" class="flex flex-col justify-between h-full py-2">
          <div class="flex flex-col">
            <div class="text-lg font-semibold border-b border-grey-lighter">
              Set this year as intervention year?
            </div>
          </div>

          <div class="w-full">
            <button class="px-2 py-1 rounded-sm text-white font-bold tile-shadow bg-green float-right hover:bg-green-dark focus:bg-green-darker disabled:cursor-not-allowed"
                    v-on:click="setInterventionYear()"
                    :disabled="this.locked"
            >
              <i class="far fa-floppy-disk"></i> Confirm
            </button>
          </div>
        </div>

        <!-- ADDITIONALITIES -->
        <div v-if="this.modalData.view === 'additionalities'" class="h-full">
          <div class="w-full h-full pb-2 flex flex-col mb-2" aria-orientation="vertical" aria-labelledby="options-menu">
            <template v-if="this.modalData.year">
              <div class="my-2 font-semibold text-xl">
                <i class="far fa-rectangle-history-circle-plus"></i> Additionalities
              </div>
              <div class="mb-auto">
                <template v-for="(additionality, index) in this.fieldYears[this.modalData.year].additionalities">
                  <div v-if="!(additionality.delete && additionality.new)" class="my-4 flex flex-col lg:flex-row justify-between items-center">
                    <div class="m-2">
                      {{ additionality.delete ? 'Deleted' : ('Practice ' + index) }}
                    </div>
                    <button v-if="additionality.delete" class="p-2 font-semibold" @click="additionality.delete = false;">
                      <i class="far fa-trash-can-arrow-up"></i>
                    </button>
                    <div class="flex items-center" v-show="!additionality.delete">
                      <div class="flex flex-col justify-between items-center items-stretch">
                        <select class="m-2 p-2" v-model="additionality.type" @change="additionalityTextInput(additionality)">
                          <option v-for="(additionalityType, index) in this.additionalityTypes" v-bind:value="index">
                            {{ additionalityType }}
                          </option>
                        </select>
                        <input v-show="additionality.text_box" v-model="additionality.practice_name" class="bg-secondary p-2 m-2" placeholder="Enter practice..."/>
                      </div>
                      <button class="p-2 font-semibold" @click="additionality.delete = true;">
                        <i class="far fa-trash"></i>
                      </button>
                    </div>
                  </div>
                </template>
              </div>
              <div class="flex justify-between w-full mt-auto rounded-md mx-1 sm:mt-0 sm:w-auto">
                <button class="px-2 py-1 rounded-sm text-white text-center font-semibold bg-green hover:bg-green-dark focus:bg-green-darker tile-shadow disabled:cursor-not-allowed"
                        v-on:click="addAdditionality(this.fieldYears[this.modalData.year])"
                        :disabled="this.locked"
                >
                  <i class="far fa-plus"></i> Additionality
                </button>
                <button class="px-2 py-1 rounded-sm text-white font-bold tile-shadow bg-green hover:bg-green-dark focus:bg-green-darker disabled:cursor-not-allowed"
                        v-on:click="setAdditionalities(this.fieldYears[this.modalData.year])"
                        :disabled="this.locked"
                >
                  <i class="far fa-floppy-disk"></i> Save
                </button>
              </div>
            </template>
          </div>
        </div>

        <!-- DELETE FIELD YEAR -->
        <div v-if="this.modalData.view === 'delete'" class="flex flex-col justify-between h-full py-2">
          <div class="flex flex-col">
            <div class="text-lg font-semibold border-b border-grey-lighter">
              Delete this field year?
            </div>
          </div>
          <div class="w-full">
            <button class="px-2 py-1 rounded-sm text-white font-bold tile-shadow bg-red float-right hover:bg-red-dark focus:bg-red-darker disabled:cursor-not-allowed"
                    v-on:click="this.$refs.deleteModal.open"
                    :disabled="this.locked">
              <i class="far fa-trash"></i> Delete
            </button>

            <Modal :small="true" ref="deleteModal">
              <div class="flex flex-row p-6 text-black">
                <i class="fad fa-3x fa-exclamation-triangle"></i>
                <div class="flex flex-col pl-4">
                  <p>
                    Are you sure you want to delete this field year? All associated crops and operations will be removed.
                  </p>
                  <p>
                    This process cannot be undone.
                  </p>
                </div>
              </div>

              <template #footer="{close,cancel}">
                <div class="w-full flex justify-between">
                  <button class="button font-bold bg-primary hover:bg-grey-lightest focus:bg-grey-lighter"
                          @click="close">
                    <span>Cancel</span>
                  </button>

                  <button class="button text-white font-bold bg-red hover:bg-red-dark focus:bg-red-darker"
                          @click="deleteResource(this.fieldYears[this.modalData.year], 'field_years')">
                    <span class="mr-1"><i class="fas fa-trash"/></span>
                    <span>Yes, Delete</span>
                  </button>
                </div>
              </template>
            </Modal>
          </div>
        </div>

      </div>

      <!-- TOOLS -->
      <div class="w-1/10 shrink-0 text-center flex flex-row lg:flex-col">
        <!-- OPERATIONS EDIT -->
        <div class="tooltip cursor-pointer px-2 py-1"
             @click="showCrop(this.modalData.crops ? Object.keys(this.modalData.crops)[0] : 0, 0)">
          <div class="tooltip-box-right-aligned">
            <div class="bg-black opacity-75 text-white p-1 rounded absolute bottom-0">
              <span>Edit Crops & Operations</span>
            </div>
          </div>
          <i class="fas fa-shovel"></i>
        </div>

        <!-- INTERVENTION YEAR -->
        <div class="tooltip cursor-pointer px-2 py-1" @click="setModalView('intervention')">
          <div class="tooltip-box-right-aligned">
            <div class="bg-black opacity-75 text-white p-1 rounded absolute bottom-0">
              <span>Set Intervention Year</span>
            </div>
          </div>
          <i class="fas fa-flag-pennant"></i>
        </div>

        <!-- ADDITIONALITIES -->
        <div class="tooltip cursor-pointer px-2 py-1" @click="setModalView('additionalities')">
          <div class="tooltip-box-right-aligned">
            <div class="bg-black opacity-75 text-white p-1 rounded absolute bottom-0">
              <span>Edit Additionalities</span>
            </div>
          </div>
          <i class="fas fa-rectangle-history-circle-plus"></i>
        </div>

        <!-- DELETE FIELD YEAR -->
        <div class="tooltip cursor-pointer px-2 py-1" @click="setModalView('delete')">
          <div class="tooltip-box-right-aligned">
            <div class="bg-black opacity-75 text-white p-1 rounded absolute bottom-0">
              <span>Delete Field Year</span>
            </div>
          </div>
          <i class="fas fa-trash"></i>
        </div>
      </div>
    </div>

    <template #toggle="{open}"></template>
    <template #footer="{close}">
      <button type="button"
              class="button button-wide bg-tertiary text-sm hover:bg-grey-lighter focus:bg-grey-light"
              v-on:click="close">
        Close
      </button>
    </template>
  </OperationsModal>
</template>
